import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import routing from "routing";
import ExamListSkeleton from "src/components/NewComponents/Skeletons/ExamsList";

import { EmptyTableBox } from "../Main/EmptyBox";
import ExamActions from "../NewComponents/menuActions/ExamActions";
import ExamView from "../NewComponents/Views/ScoreViews/ExamView";
import PaginatedTable from "./PaginatedTable";

interface TableHeader {
	key?: string;
	value?: string;
}

interface ExamRow {
	kategoria: string;
	[key: string]: unknown;
}

interface DefaultExamTableProps {
	headers: TableHeader[];
	getItems: (details: any) => { data?: { rows: ExamRow[]; count: number }; isLoading: boolean };
	onSelectActions?: () => Array<{ title: string; onClick: (event: React.MouseEvent) => void }>;
	renderRow: (row: any) => ReactNode;
	[key: string]: unknown;
}

export default function DefaultExamTable(props: DefaultExamTableProps) {
	const { t } = useTranslation();

	return (
		<PaginatedTable
			{...props}
			getRows={props.getItems}
			getOnSelectActions={props.onSelectActions}
			getRowName={(row: ExamRow) => row.kategoria}
			getRowProps={(row: ExamRow) => ({ "data-test-id": "exam-list-item", "data-exam-id": row.id })}
			Skeleton={
				<ExamListSkeleton columns={props.headers.length - 1} rows={10} />
			}
			defaultOrder="updatedAt"
			renderMobileRow={(row: ExamRow & { disabled: boolean }, className: string) => (
				<ExamView row={row} className={className} />
			)}
			RowActions={ExamActions}
			EmptyBox={
				<EmptyTableBox
					title={t("table.exam.empty.title")}
					subtitle={t("table.exam.empty.submitText")}
				/>
			}
		/>
	);
}
